import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  main: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      paddingBottom: 56,
      backgroundColor: '#FFF',
      minHeight: 'initial',
      flex: 1,
    },
  },
  primary: {
    minHeight: '100vh',
    height: 'auto',
    flex: 1,
    backgroundColor: '#FFF',
    padding: '40px 56px',
    paddingTop: 0,
    position: 'relative',
    paddingBottom: 56,
    [theme.breakpoints.down('sm')]: {
      minHeight: 'auto',
      height: 'auto',
      padding: '0',
      width: '100%',
    },
  },
  primaryCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  primaryInner: {
    display: 'flex',
    flexDirection: 'row',
    // justifyContent: 'flex-start',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      background: 'white',
      padding: '32px 24px',
    },
  },
  primaryForm: {
    maxWidth: '100%',
    width: 592,
  },
  primaryFormFullWidth: {
    maxWidth: '100%',
    width: '100%',
  },
  secondary: {
    width: 416,
    minHeight: '100%',
    height: 'auto',
    padding: '40px 48px',
    [theme.breakpoints.down('md')]: {
      padding: '40px 36px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      position: 'initial',
      minHeight: 'auto',
      height: 'auto',
      padding: 0,
    },
  },
  bottomNavigation: {
    background: 'white',
    width: '100%',
    top: 'initial',
    bottom: 0,
    height: 'auto',
    padding: '8px 16px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px -1px 1px rgba(0,0,0,0.13)',
  },
  back: {
    fontWeight: 300,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.secondary.dark,
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textDecoration: 'none',
    paddingRight: 16,
  },
  backIcon: {
    marginRight: 8,
    width: 24,
  },
  bottomButton: {
    width: 172,
    paddingTop: '8px',
    paddingBottom: '8px',
    marginTop: '0px',
    marginBottom: '0px',
  },
  consent: {
    zIndex: 2000, // Keep above the "continue" button on mobile
    position: 'absolute',
    width: '80%',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: 45,
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 16px)',
      position: 'fixed',
      bottom: '8px',
    },
  },
}))

export default useStyles
